module.exports = __webpack_public_path__ + "static/media/baseline-remove-24px.ef5422db.svg";